import React, { FC } from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { FormRowComponent, FormRowElement, InputComponent, AddressComponent } from 'LibNeo'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'
import { ADDRESS_LABEL, ADDRESS_TYPE } from 'Constants/Address.constants'
import { getAddressText, HiddenStyled } from 'Pages/ibro'
import { AddressSuggest } from 'Models'
import { AddressComponentWrapper } from './styled'

interface ComponentProps {
	form: WrappedFormUtils
	defaultAddress: AddressSuggest
	fieldName: FieldNames
	origin?: string
	label?: ADDRESS_LABEL
	fields: FieldNames[]
	lockedElem?: string
	lockedFields: FieldNames[]
	fieldOptions?: GetFieldDecoratorOptions
	placeholder?: string
	hiddenFields?: FieldNames[]
}

export const BgAddresComponent: FC<ComponentProps> = ({
	form,
	defaultAddress,
	fieldName,
	origin,
	label,
	fields,
	lockedElem,
	lockedFields,
	fieldOptions,
	placeholder,
	hiddenFields,
}) => {
	if (!fields.includes(fieldName)) return null

	if (hiddenFields?.includes(fieldName))
		return (
			<FormRowComponent label={label || ''} isString>
				<FormRowElement>{getAddressText(undefined)}</FormRowElement>
				<HiddenStyled>
					<InputComponent
						fieldName={fieldName}
						form={form}
						fieldOptions={{
							initialValue: defaultAddress,
						}}
					/>
				</HiddenStyled>
			</FormRowComponent>
		)

	if (lockedFields.includes(fieldName))
		return (
			<FormRowComponent label={label || ''} isString>
				<FormRowElement>{lockedElem || '-'}</FormRowElement>
				<HiddenStyled>
					<InputComponent
						fieldName={fieldName}
						form={form}
						fieldOptions={{
							initialValue: defaultAddress,
						}}
					/>
				</HiddenStyled>
			</FormRowComponent>
		)

	return (
		<AddressComponentWrapper>
			<AddressComponent
				form={form}
				fieldName={fieldName}
				currentAddress={form.getFieldValue(fieldName)}
				defaultAddress={defaultAddress}
				origin={origin}
				fieldLabel={label}
				fieldOptions={fieldOptions}
				placeholder={placeholder}
				hideCompareAddressTitle
				hasFormRow
				typeAddress={ADDRESS_TYPE.IBRO}
			/>
		</AddressComponentWrapper>
	)
}
